import React from 'react';
import { useTranslation } from 'react-i18next';
import logoWhite from '../assets/logo-white.svg';
import { CONTACT_EMAIL } from '../utils/contact';
import './Footer.css';

const APP_URL = process.env.REACT_APP_APP_URL || 'https://app.libbenincorp.com';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src={logoWhite} alt="LibbenIncorp" className="footer-logo" />
          <p className="footer-tagline">{t('footer.tagline')}</p>
        </div>

        <div className="footer-col">
          <h4>{t('footer.product')}</h4>
          <a href="/#features">{t('footer.links.features')}</a>
          <a href="/#modules">{t('footer.links.modules')}</a>
          <a href="/#pricing">{t('footer.links.pricing')}</a>
          <a href="/#faq">{t('footer.links.faq')}</a>
        </div>

        <div className="footer-col">
          <h4>{t('footer.company')}</h4>
          <a href={`mailto:${CONTACT_EMAIL}`}>{t('footer.links.contact')}</a>
        </div>

        <div className="footer-col">
          <h4>{t('footer.legal')}</h4>
          <a href="/termos">{t('footer.links.terms')}</a>
          <a href="/privacidade">{t('footer.links.privacy')}</a>
          <a href="/cookies">{t('footer.links.cookies')}</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t('footer.copyright')}</p>
        <a href={`${APP_URL}/login`} className="footer-login">
          {t('nav.login')} →
        </a>
      </div>
    </footer>
  );
}
